export default __webpack_public_path__ + "static/media/xcovers-4-rMAX.409d77ea.jpg";